/**
 * Los últimos sitios abiertos desde el buscador, para ofrecerlos con el campo vacío.
 *
 * ⚠ **En el navegador, como el tema y las secciones abiertas**: es una comodidad de
 * cada quien en cada equipo, y perderla —otro navegador, datos borrados— sólo cuesta
 * volver a escribir. Se guardan RUTAS, nunca lo escrito: lo tecleado no se recuerda en
 * ningún sitio. Y entre `try`: en una ventana privada el simple acceso lanza.
 *
 * ⚠ **Por PERSONA** (05/11): en un equipo compartido, quien entra después no ve qué
 * abrió la anterior.
 */

const clave = (usuarioId: number) => `setieca:buscador:recientes:${usuarioId}`
export const MAXIMO_RECIENTES = 5

export function leerRecientes(usuarioId: number): string[] {
  try {
    const crudo = window.localStorage.getItem(clave(usuarioId))
    const valor: unknown = crudo === null ? [] : JSON.parse(crudo)
    return Array.isArray(valor)
      ? valor.filter((r): r is string => typeof r === "string").slice(0, MAXIMO_RECIENTES)
      : []
  } catch {
    return []
  }
}

/** La ruta pasa al principio, sin repetirse. */
export function recordarReciente(usuarioId: number, ruta: string): void {
  const siguiente = [ruta, ...leerRecientes(usuarioId).filter((r) => r !== ruta)].slice(
    0,
    MAXIMO_RECIENTES,
  )
  try {
    window.localStorage.setItem(clave(usuarioId), JSON.stringify(siguiente))
  } catch {
    // Sin sitio donde recordarlo, no se ofrecerá la próxima vez. No es un fallo.
  }
}
